export default {
  NO_OPTION: `No options`,
  PLACEHOLDER: `Search here`
}
